import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryButtons from './components/CategoryButtons';
import AboutSection from './components/AboutSection';
import FeatureGrid from './components/FeatureGrid';
import KnowledgeHub from './components/KnowledgeHub';
import SocialProof from './components/SocialProof';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <CategoryButtons />
        <AboutSection />
        <FeatureGrid />
        <KnowledgeHub />
        <SocialProof />
        <CTASection />
      </main>

      {/* Organization Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Superbuy Sheet',
            url: 'https://superbuysheet.hair',
            description: 'Superbuy Spreadsheet helps shoppers discover, compare and understand products through organized resources, curated category databases and expert shopping guides.',
          }),
        }}
      />

      {/* Website Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'Superbuy Sheet',
            url: 'https://superbuysheet.hair',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://kaspreadsheet.com/search?s={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />

      {/* Breadcrumb Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home',
                item: 'https://superbuysheet.hair/',
              },
            ],
          }),
        }}
      />

      <Footer />
    </div>
  );
}